import React from 'react';

const AboutEnculture = () => {
  return (
    <section className="py-20 bg-white opacity-0 animate-fadeIn-delayed-7">
      <div className="w-[90%] max-w-[1200px] mx-auto px-5">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_1.2fr] gap-[60px] items-start">
          <div className="about-left">
            <h2 className="font-heading font-semibold text-[2rem] text-left text-[#6B4DC4] mb-[25px]">
              About Enculture
            </h2>
            <p className="text-[1.05rem] leading-[1.7] mb-[25px] text-[#333333]">
              Backed by NamanHR's 20+ years of HR consulting expertise, Enculture is fast to implement, intuitive to adopt, 
              and more than a survey tool – it's a strategic operating system for culture.
            </p>
            <a 
              href="https://enculture.ai" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block bg-gradient-to-br from-[#6B4DC4] to-[#4ECDC4] text-white font-heading font-semibold py-3 px-7 rounded-[25px] uppercase tracking-[1px] text-[0.95rem] transition-all duration-300 shadow-[0_4px_15px_rgba(107,77,196,0.4)] hover:bg-gradient-to-br hover:from-[#4ECDC4] hover:to-[#6B4DC4] hover:-translate-y-[3px] hover:shadow-[0_6px_25px_rgba(78,205,196,0.5)]"
            >
              Know More
            </a>
          </div>
          <div className="about-right">
            <p className="text-[1.05rem] leading-[1.7] mb-5 text-[#333333]">
              Enculture is an AI-powered culture intelligence platform that helps organizations measure, align, and strengthen 
              workplace culture through real-time insights.
            </p>
            <ul className="list-none p-0 m-0">
              <li className="py-3 text-base leading-relaxed text-[#333333] border-b border-[rgba(107,77,196,0.1)] last:border-b-0">
                <strong className="text-[#6B4DC4] font-semibold">Listen:</strong> Smart, contextual surveys designed to reflect today's reality
              </li>
              <li className="py-3 text-base leading-relaxed text-[#333333] border-b border-[rgba(107,77,196,0.1)] last:border-b-0">
                <strong className="text-[#6B4DC4] font-semibold">Engage:</strong> Dashboards revealing sentiment trends & culture drivers
              </li>
              <li className="py-3 text-base leading-relaxed text-[#333333] border-b border-[rgba(107,77,196,0.1)] last:border-b-0">
                <strong className="text-[#6B4DC4] font-semibold">Perform:</strong> Insights that help leaders align teams and act strategically
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutEnculture;

